import { combineReducers } from 'redux';
import diagram from './diagram';
import main from './main';
import canvas from './canvas';
import auth from "./auth";
import notify from './notify';
import workspace from './workspace';
import invitation from './invitation';

const rootReducer = combineReducers({
    diagram,
    main,
    canvas,
    auth,
    notify,
    workspace,
    invitation,
});

export default rootReducer;
